<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <evaluado-info-card-component :expediente="expediente[0]" />
      </v-col>
      <v-col cols="12">
        <v-card
          class="card"
          color="primary"
        >
          <v-card-title class="font-weight-bold justify-center">
            Evaluación poligráfica
          </v-card-title>
          <v-card-text>
            <v-container class="mb-4">
              <v-row
                align="center"
                justify="center"
              >
                <v-col align="right">
                  <v-progress-circular
                    :value="activeStep * 20"
                    v-bind="circularProgressProps"
                  />
                </v-col>
                <v-col>
                  <div class="text-caption text--primary">
                    PASO {{ activeStep }}
                  </div>
                  <div class="text-subtitle-1 font-weight-bold text--primary">
                    {{ activeStepTitle }}
                  </div>
                  <a
                    v-show="activeStep !== 1"
                    class="text-decoration-none secondary--text"
                    @click="activeStep--"
                    @keydown="activeStep--"
                  >Volver al paso anterior</a>
                </v-col>
              </v-row>
            </v-container>
            <v-container v-if="activeStep === 1">
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="poligrafo.antecedentesLaborales"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Antecedentes laborales"
                    no-resize
                    rows="16"
                  />
                </v-col>
              </v-row>
            </v-container>
            <v-container v-if="activeStep === 2">
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="poligrafo.situacionPatrimonial"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Situación patrimonial"
                    no-resize
                    rows="16"
                  />
                </v-col>
              </v-row>
            </v-container>
            <v-container v-if="activeStep === 3">
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="poligrafo.admisiones"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Admisiones"
                    no-resize
                    rows="16"
                  />
                </v-col>
              </v-row>
            </v-container>
            <v-container v-if="activeStep === 4">
              <v-row>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn-toggle
                    v-model="preguntas"
                    color="grey"
                    rounded
                    mandatory
                  >
                    <v-btn color="secondary">
                      Tres preguntas
                    </v-btn>
                    <v-btn color="secondary">
                      Cuatro preguntas
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        v-model="poligrafo.observaciones"
                        rounded
                        filled
                        dense
                        background-color="primary"
                        color="secondary"
                        label="Observaciones 3 preguntas"
                        no-resize
                        rows="12"
                      />
                    </v-col>
                  </v-row>
                  <v-row v-if="poligrafo.opcIndiObserv !== 1">
                    <v-col cols="8">
                      <v-text-field
                        v-model="poligrafo.preguntas[0].pregunta"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        label="Pregunta 1"
                      />
                      <v-text-field
                        v-model="poligrafo.preguntas[1].pregunta"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        label="Pregunta 2"
                      />
                      <v-text-field
                        v-model="poligrafo.preguntas[2].pregunta"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        label="Pregunta 3"
                      />
                      <v-text-field
                        v-if="preguntas === 1"
                        v-model="poligrafo.preguntas[3].pregunta"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        label="Pregunta 4"
                      />
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="poligrafo.preguntas[0].puntaje"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        label="Puntaje de pregunta 1"
                      />
                      <v-text-field
                        v-model="poligrafo.preguntas[1].puntaje"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        label="Puntaje de pregunta 2"
                      />
                      <v-text-field
                        v-model="poligrafo.preguntas[2].puntaje"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        label="Puntaje de pregunta 3"
                      />
                      <v-text-field
                        v-if="preguntas === 1"
                        v-model="poligrafo.preguntas[3].puntaje"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        label="Puntaje de pregunta 4"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
            <v-container v-if="activeStep === 5">
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="poligrafo.sintesisTecnica"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Síntesis técnica"
                    no-resize
                    rows="6"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="poligrafo.indicadores[0].indicador"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    label="Campo"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="poligrafo.indicadores[1].indicador"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    label="Campo"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="poligrafo.indicadores[2].indicador"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    label="Campo"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="poligrafo.indicadores[3].indicador"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    label="Campo"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="poligrafo.indicadores[4].indicador"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    label="Campo"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="poligrafo.indicadores[5].indicador"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    label="Campo"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    v-if="preguntas === 1"
                    v-model="poligrafo.indicadores[6].indicador"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    label="Campo"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    v-if="preguntas === 1"
                    v-model="poligrafo.indicadores[7].indicador"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    label="Campo"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="poligrafo.diagnosticoPreliminar"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Diagnóstico preliminar"
                    no-resize
                    rows="6"
                    :rules="required"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    :value="nombre"
                    readonly
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    label="Elaboró"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="poligrafo.evaluadorReviso"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    label="Revisó"
                  />
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="poligrafo.fk_idCatSemaforoResultado"
                    label="Semáforo de resultado"
                    background-color="primary"
                    color="secondary"
                    rounded
                    filled
                    dense
                    :items="semaforoResultado"
                    item-value="id"
                    item-text="nombre"
                    item-color="secondary"
                    :rules="required"
                  />
                </v-col>
              </v-row>
            </v-container>
            <v-container>
              <v-row>
                <v-col
                  md="12"
                  align="center"
                >
                  <v-btn
                    rounded
                    class="mx-8"
                    elevation="8"
                    color="secondary"
                    :loading="loading"
                    :disabled="!validActiveStep || loading"
                    @click="activeStepButtonHandler"
                  >
                    {{ activeStepButtonLabel }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-overlay
      :value="overlay"
      :z-index="999"
      align="center"
      color="secondary"
      opacity="1"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
      <div class="text-overline mt-4">
        Cargando información. Por favor, espere...
      </div>
    </v-overlay>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { circularProgressProps } from '../../components/props/props';
import EvaluadoInfoCardComponent from '../../components/EvaluadoInfoCardComponent.vue';

export default {
  name: 'EvaluacionView',
  components: {
    EvaluadoInfoCardComponent,
  },

  props: {
    idDerivacion: {
      type: Number,
      required: true,
    },
    idProgramacion: {
      type: Number,
      required: true,
    },
    idExpediente: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      circularProgressProps,
      activeStep: 1,
      overlay: false,

      loading: false,
      poligrafoForm: false,
      preguntas: 0,

      poligrafo: {
        fk_idDerivacion: this.idDerivacion,
        fk_idProgramacion: this.idProgramacion,
        fk_idExpediente: this.idExpediente,
        antecedentesLaborales: '',
        situacionPatrimonial: '',
        opcIndiObserv: 0,
        opcPreguntas: 0,
        opc3Preguntas: 0,
        opc4Preguntas: 0,
        observaciones: '',
        sintesisTecnica: '',
        diagnosticoPreliminar: '',
        fk_idEvaluadorElaboro: null,
        evaluadorReviso: '',
        preguntas: [
          {
            pregunta: '',
            puntaje: '',
          },
          {
            pregunta: '',
            puntaje: '',
          },
          {
            pregunta: '',
            puntaje: '',
          },
          {
            pregunta: '',
            puntaje: '',
          },
        ],
        indicadores: [
          {
            indicador: '',
          },
          {
            indicador: '',
          },
          {
            indicador: '',
          },
          {
            indicador: '',
          },
          {
            indicador: '',
          },
          {
            indicador: '',
          },
          {
            indicador: '',
          },
          {
            indicador: '',
          },
        ],
        admisiones: '',
        fk_idCatSemaforoResultado: null,
      },

      required: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  computed: {
    ...mapGetters('evaluadores', {
      evaluadores: 'getEvaluadores',
    }),

    ...mapGetters({
      nombre: 'getNombre',
      idPersonal: 'getIdPersonal',
    }),

    ...mapGetters('expediente', {
      expediente: 'getExpedientesPersonal',
    }),

    ...mapGetters('semaforoResultado', {
      semaforoResultado: 'getSemaforoResultado',
    }),

    ...mapGetters('datosLaborales', {
      datosLaborales: 'getDatosLaborales',
    }),

    ...mapGetters('situacionFinanciera', {
      situacionFinanciera: 'getSituacionFinanciera',
    }),

    activeStepTitle() {
      switch (this.activeStep) {
        case 1:
          return 'Antecedentes laborales';
        case 2:
          return 'Situación patrimonial';
        case 3:
          return 'Admisiones';
        case 4:
          return 'Observaciones';
        case 5:
          return 'Síntesis técnica';
        default:
          return '';
      }
    },

    validActiveStep() {
      switch (this.activeStep) {
        case 1:
          return true;
        case 2:
          return true;
        case 3:
          return true;
        case 4:
          return true;
        case 5:
          return true;
        default:
          return false;
      }
    },

    activeStepButtonLabel() {
      if (this.activeStep < 5) {
        return 'Siguiente paso';
      }
      return 'Registrar evaluación';
    },
  },

  watch: {
    datosLaborales: {
      handler(newValue) {
        if (newValue.length > 0) {
          let text = '';
          newValue.forEach((datoLaboral) => {
            text
                                += `\nEmpresa: ${datoLaboral.empresa}\nPeriodo: ${datoLaboral.periodo}\nPuesto: ${datoLaboral.puesto}\nFunciones que desempeñaba: ${datoLaboral.puesto}\n-------------------------------------------------`;
          });
          this.poligrafo.antecedentesLaborales = text;
        }
      },
    },

    situacionFinanciera: {
      handler(newValue) {
        if (newValue.length > 0) {
          let text = `\nIngreso: ${newValue[0].CatIngreso.title}\nNivel socioeconómico: ${newValue[0].CatNivelSocioeconomico.title}\nDependientes economicos: ${newValue[0].dependientesEconomicos}\nServicios:\n`;
          newValue[0].servicios.forEach((servicio) => {
            text += `${servicio.CatServicios.title}\n`;
          });
          this.poligrafo.situacionPatrimonial = text;
        }
      },
    },
  },

  async mounted() {
    this.overlay = true;
    await this.fetchExpedienteById(this.idExpediente);
    await this.fetchDatosLaborales(this.idExpediente);
    await this.fetchSituacionFinanciera(this.idExpediente);
    this.overlay = false;
  },

  methods: {
    ...mapActions('expediente', ['fetchExpedienteById']),
    ...mapActions('diagnostico', ['fetchDiagnostico']),
    ...mapActions('evaluacionesPoligrafo', ['saveEvaluacionPoligrafo']),
    ...mapActions('derivaciones', ['updateDerivacion', 'updateEstatusDerivacion', 'fetchDerivacionesByArea']),
    ...mapActions('datosLaborales', ['fetchDatosLaborales']),
    ...mapActions('situacionFinanciera', ['fetchSituacionFinanciera']),

    async activeStepButtonHandler() {
      if (this.activeStep < 5) {
        this.activeStep += 1;
      } else {
        this.loading = true;

        this.poligrafo.fk_idEvaluadorElaboro = 1;
        await this.saveEvaluacionPoligrafo(this.poligrafo);
        await this.updateEstatusDerivacion({
          fk_idProgramacion: this.idProgramacion,
          idDerivacion: this.idDerivacion,
        });

        await this.fetchDerivacionesByArea(18);

        this.loading = false;
        this.$router.push('/evaluaciones_poligraficas/personal');
      }
    },

    nextStepAdmisiones() {
      this.activeStep = 3;
      this.poligrafo.opcIndiObserv = 0;
    },

    nextStepObservaciones() {
      this.activeStep = 3;
      this.poligrafo.opcIndiObserv = 1;
    },
  },
};
</script>
